import { Button } from '@mui/material'
import { useConfigBasedIngestion } from './configBasedIngestion'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { ingestedTreeAtom } from './atoms'
import { uploadCourse } from '../../components/ingestion/Utility'
import { partnerIdAtom } from '../../components/ingestion/atoms'

export function DoIngestButton() {
  const { canIngest, doIngest } = useConfigBasedIngestion()
  return (
    <Button disabled={!canIngest} onClick={doIngest}>
      Do Ingest
    </Button>
  )
}

export function UploadIngestedButton() {
  const ingestedTree = useAtomValue(ingestedTreeAtom)
  const partnerKey = useAtomValue(partnerIdAtom)
  const createTree = () => {
    if (!ingestedTree) return
    uploadCourse(partnerKey, ingestedTree)
  }
  return (
    <Button disabled={!ingestedTree} onClick={createTree}>
      Upload Ingestion
    </Button>
  )
}
